<template>
  <v-hover v-slot="{ hover }">
    <v-card :elevation="hover ? 6 : 2">
      <v-card-title>
        <div
          :class="(asset.maintenance) ? 'text-left text-h5 font-weight-bold grey--text' : 'text-left text-h5 font-weight-bold black--text'">
          <v-icon>mdi-air-filter</v-icon>{{ asset.assetName }} <v-icon v-if="asset.maintenance"
            small>mdi-wrench</v-icon>
          <ASSET_ALERT_ICON :asset="asset" />
        </div>
        <v-spacer></v-spacer>
        <ASSET_MENU :asset="asset" />
      </v-card-title>
      <v-card-text>
        <v-row dense align="stretch">
          <v-col cols="12" md="4">
            <v-sheet class="summary-sheet" elevation="0" rounded>
              <div class="summary-header">
                <div class="section-title">สรุปคุณภาพอากาศ</div>
                <v-chip class="ma-0" small color="primary" text-color="white">24 Hr Window</v-chip>
              </div>
              <v-divider></v-divider>
              <div class="summary-content">
                <div class="summary-icon">
                  <AqiCircleChart :aqi="primaryAqi" />
                </div>
                <div class="summary-details">
                  <div class="summary-chip">
                    <v-chip outlined small color="primary" class="px-3">
                      {{ selectedElement }} · {{ units[selectedElement] || '-' }}
                    </v-chip>
                  </div>
                  <div class="stat-row">
                    <div class="stat-block">
                      <div class="stat-label">Current</div>
                      <div class="stat-value">{{ currentValue }}<span class="stat-unit">{{ units[selectedElement] || '' }}</span></div>
                      <div class="stat-sublabel">{{ selectedElement }}</div>
                    </div>
                    <div class="stat-block">
                      <div class="stat-label">24 Hr Avg</div>
                      <div class="stat-value">{{ avgValue }}<span class="stat-unit">{{ units[selectedElement] || '' }}</span></div>
                      <div class="stat-sublabel">{{ selectedElement }}</div>
                    </div>
                  </div>
                  <div class="info-badges">
                    <div class="info-pill">
                      <v-icon small>mdi-clock-outline</v-icon>
                      <span>{{ lastUpdated }}</span>
                    </div>
                    <div class="info-pill">
                      <v-icon small>mdi-map-marker</v-icon>
                      <span>{{ asset.location }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </v-sheet>
          </v-col>
          <v-col cols="12" md="8">
            <v-sheet class="pa-4 combined-sheet" elevation="0" rounded>
              <div class="combined-header">
                <div class="section-title">ข้อมูลล่าสุดและแนวโน้มรายชั่วโมง</div>
                <div class="combined-hint">Tap a metric to update the chart</div>
              </div>
              <div class="combined-content">
                <div class="combined-table">
                  <v-simple-table dense>
                    <template v-slot:default>
                      <tbody>
                        <tr v-for="(subItem, index) in sensorKeys" :key="index"
                          :class="{ 'active-row': subItem === selectedElement }"
                          @click="selectedRow(subItem)">
                          <td class="center-text text-subtitle-1" width="120px">
                            {{ subItem }}
                          </td>
                          <td class="center-text text-subtitle-1 font-weight-bold" width="60px">
                            {{ parsedAssetData[subItem] }}
                          </td>
                          <td class="center-text text-subtitle-1" width="60px">{{ units[subItem] }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </div>
                <div class="combined-chart">
                  <AIR_QUALITY_HOUR_CHART :element="selectedElement" :unit="units[selectedElement]" :data="data"
                    :category="category" />
                </div>
              </div>
            </v-sheet>
          </v-col>
          <v-col cols="12">
            <v-sheet class="pa-4 heatmap-sheet" elevation="0" rounded>
              <div class="section-title text-center mb-4">ข้อมูลคุณภาพอากาศย้อนหลัง 7 วัน</div>
              <AIR_QUALITY_HEATMAP :element="selectedElement" :unit="units[selectedElement]" :data="weeklyData" />
            </v-sheet>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-hover>

</template>
<script>
import AqiCircleChart from '@/components/air_quality/aqi_circle_chart.vue';
import AIR_QUALITY_HOUR_CHART from '@/components/air_quality/air_quality_hour_chart.vue';
import AIR_QUALITY_HEATMAP from '@/components/air_quality/air_quality_heatmap.vue';
import * as alasql from 'alasql'
import DateRangePicker from '@/components/common/DateRangePicker.vue'
import ASSET_MENU from '@/components/asset/asset_menu.vue'
import ASSET_ALERT_ICON from '@/components/asset/asset_alert_icon.vue'

export default {
  name: 'AirQualityView',
  props: {
    asset: {
      type: Object
    },
  },
  components: {
    AqiCircleChart,
    DateRangePicker,
    ASSET_MENU,
    ASSET_ALERT_ICON,
    AIR_QUALITY_HOUR_CHART,
    AIR_QUALITY_HEATMAP

  },
  data() {
    return {
      myChart: null,
      data: [],
      category: [],
      weeklyData: [],
      weeklyCategory: [],
      historyDialog: false,
      editDialog: false,
      currentItem: null,
      alertDialog: false,
      tokenDialog: false,
      emailDialog: false,
      alertHistoryDialog: false,
      selectedElement: 'PM25',
      avgValue: '-',
      tsItems: [],
      weeklyItems: [],
      range: {
        startDate: this.$dayjs().local().subtract('day', 7).startOf('day').toDate(),
        endDate: this.$dayjs().local().endOf('day').toDate(),
      },
    }
  },
  computed: {
    units() {
      return this.$store.state.User.units
    },
    building: {
      get: function () {
        return this.$store.state.User.building
      },
      set: function (newValue) {
        this.$store.dispatch('User/SET_BUILDING', newValue)
      }
    },
    parsedAssetData() {
      if (!this.asset || !this.asset.data) {
        return {}
      }
      try {
        return JSON.parse(this.asset.data)
      } catch (error) {
        return {}
      }
    },
    sensorKeys() {
      return Object.keys(this.parsedAssetData)
    },
    primaryAqi() {
      const rawValue = this.parsedAssetData[this.selectedElement]
      const numericValue = Number(rawValue)
      return Number.isFinite(numericValue) ? numericValue : 0
    },
    currentValue() {
      const rawValue = this.parsedAssetData[this.selectedElement]
      if (rawValue === undefined || rawValue === null || rawValue === '') {
        return '-'
      }
      const numericValue = Number(rawValue)
      return Number.isFinite(numericValue) ? numericValue.toFixed(2) : rawValue
    },
    lastUpdated() {
      if (!this.asset || !this.asset.heartbeat) {
        return '-'
      }
      return this.$dayjs(this.asset.heartbeat).format('LLL')
    }
  },
  mounted() {
    this.getTSData()
    this.getHeatmapData()
  },
  methods: {
    selectedRow(item) {
      this.selectedElement = item
      this.setElementTS()
      this.setElementHeatMap()
    },
    setElementTS() {
      // SET TS chart
      this.category = this.tsItems.map((x) => this.$dayjs(x.date + ' ' + x.H + ':00', "YY-MM-DD H:mm").format("YY-MM-DD H:mm"))
      this.data = this.tsItems.map((x) => Number(x[this.selectedElement]).toFixed(2))
      const numericValues = this.tsItems
        .map((x) => Number(x[this.selectedElement]))
        .filter((value) => !Number.isNaN(value))
      if (numericValues.length) {
        const total = numericValues.reduce((sum, value) => sum + value, 0)
        this.avgValue = (total / numericValues.length).toFixed(2)
      } else {
        this.avgValue = '-'
      }
    },
    setElementHeatMap() {
      // SET HEATMAP chart
      let dataGroup = alasql(`select weekDay, H, MAX(${this.selectedElement}) as ${this.selectedElement} from ? group by weekDay, H`, [this.weeklyItems])
      this.weeklyData = dataGroup.map(a => [Number(a.weekDay), Number(a.H), Number(a[this.selectedElement])]).map(function (item) {
        return [item[1], item[0], item[2].toFixed(1) || '-'];
      })
    },
    getTSData() {
      this.$store.dispatch('Air/GET_AIR', {
        BuildingId: this.building.BuildingId,
        deviceId: this.asset.deviceId,
        start: Math.floor(this.$dayjs().local().subtract(1, 'day').valueOf()),
        end: Math.floor(this.$dayjs().local().valueOf()),
        type: 'hourly',
        group: true
      }).then((data) => {
        this.tsItems = data.sort((a, b) => {
          let dateA = this.$dayjs(a.date + ' ' + a.H + ':00', "YY-MM-DD H:mm")
          let dateB = this.$dayjs(b.date + ' ' + b.H + ':00', "YY-MM-DD H:mm")
          if (dateA.isAfter(dateB)) {
            return 1
          } else {
            return -1
          }
        })
        this.setElementTS()
      })
    },
    getHeatmapData() {
      this.$store.dispatch('Air/GET_AIR', {
        BuildingId: this.building.BuildingId,
        deviceId: this.asset.deviceId,
        start: Math.floor(this.$dayjs().local().subtract(1, 'week').startOf('week').valueOf()),
        end: Math.floor(this.$dayjs().local().valueOf()),
        type: 'hourly',
        group: true
      }).then((data) => {
        this.weeklyItems = data
        this.setElementHeatMap()
      })
    }
  },
}


</script>

<style scoped>
.summary-sheet {
  background-color: #f9fbff;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 100%;
  padding: 20px;
}

.combined-sheet,
.heatmap-sheet {
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 100%;
}

.section-title {
  font-weight: 600;
  font-size: 1rem;
  color: #1f2933;
}

.summary-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.summary-content {
  display: flex;
  align-items: center;
  gap: 16px;
}

.summary-icon {
  flex: 0 0 120px;
  display: flex;
  justify-content: center;
}

.summary-details {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.summary-chip {
  display: flex;
  justify-content: flex-start;
}

.stat-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.stat-block {
  flex: 1 1 140px;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 8px;
  padding: 8px 12px;
  text-align: center;
  box-shadow: inset 0 0 0 1px rgba(33, 150, 243, 0.1);
}

.stat-label {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: rgba(0, 0, 0, 0.54);
}

.stat-value {
  font-size: 1.4rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.87);
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 6px;
}

.stat-unit {
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.54);
}

.stat-sublabel {
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.45);
}

.info-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.info-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 999px;
  background-color: rgba(33, 150, 243, 0.08);
  color: rgba(0, 0, 0, 0.7);
  font-size: 0.8rem;
}

.combined-header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
}

.combined-hint {
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.5);
}

.combined-content {
  display: flex;
  gap: 24px;
  align-items: stretch;
}

.combined-table {
  flex: 0 0 240px;
}

.combined-table table {
  width: 100%;
}

.combined-table tbody tr {
  cursor: pointer;
}

.combined-table tbody tr:hover {
  background-color: rgba(33, 150, 243, 0.05);
}

.combined-chart {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
}

.combined-chart > * {
  width: 100%;
}

.active-row {
  background-color: rgba(33, 150, 243, 0.1);
}

.active-row td {
  font-weight: 600;
}

.heatmap-sheet {
  margin-top: 16px;
}

@media (max-width: 1264px) {
  .summary-content {
    flex-direction: column;
    align-items: flex-start;
  }

  .summary-icon {
    flex: none;
  }

  .combined-content {
    flex-direction: column;
  }

  .combined-table {
    flex: none;
  }
}

@media (max-width: 960px) {
  .heatmap-sheet {
    margin-top: 0;
  }
}
</style>
